import axios from 'axios';
import { API_CONFIG } from '../config';

const getBaseUrl = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    console.log('REACT_APP_API_URL:', apiUrl);
    if (!apiUrl) {
        console.error('REACT_APP_API_URL is not defined');
        return '';
    }
    
    // Удаляем протокол, если он есть
    const cleanUrl = apiUrl.replace(/^https?:\/\//, '');
    // Добавляем https:// и сохраняем путь
    return `https://${cleanUrl}`;
};

const api = axios.create({
    baseURL: getBaseUrl(),
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to add the auth token to requests
api.interceptors.request.use(
    (config) => {
        // Гарантируем, что URL использует HTTPS
        if (config.baseURL && !config.baseURL.startsWith('https://')) {
            config.baseURL = config.baseURL.replace(/^http:\/\//, 'https://');
        }
        
        console.log('Request URL:', (config.baseURL || '') + (config.url || ''));
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to log errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('API Error:', {
            url: error.config?.url,
            method: error.config?.method,
            status: error.response?.status,
            data: error.response?.data,
        });
        return Promise.reject(error);
    }
);

export { api }; 